import React from "react";
import ResetLayoutsToDefault from "../ReactGridLayoutComponents/ResetLayoutsToDefault";
import ClearLayoutsRGL from "../ReactGridLayoutComponents/ClearLayoutsRGL";
import { Tooltip } from "react-tooltip";
import { moreOptionsIcon } from "@/components/icons/SVGIcons";
import SVGandTextContainer from "./SVGandTextContainer";
import AddNewWorkspaceButton from "./AddNewWorkspaceButton";
import { cubeCustomColors } from "../../../../tailwind.config";

const MoreOptionsButton = ({
  toolbarOpen,
  theme,
  getAccessTokenSilently,
}: {
  toolbarOpen: boolean;
  theme: string | undefined;
  getAccessTokenSilently: Function;
  firstLoad: boolean;
}) => {
  const cubeBase700 = cubeCustomColors.cubeBase[700];
  const cubeBaseDark700 = cubeCustomColors.cubeBaseDark[700];

  return (
    <div className={`${toolbarOpen ? "ml-1" : ""}`}>
      <SVGandTextContainer
        tooltipID={"moreOptions"}
        SVGIcon={moreOptionsIcon}
        toolbarOpen={toolbarOpen}
        openText={"More Options"}
      />
      <Tooltip
        id={"moreOptions"}
        place="right-start"
        variant="info"
        className="z-20"
        clickable={true}
        // openOnClick={true}
        opacity={1}
        style={{
          backgroundColor: theme == "dark" ? cubeBaseDark700 : cubeBase700,
          margin: "0px",
          padding: "2px",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
        border="1px solid gray"
        offset={20}
      >
        <div className="z-40">
          <AddNewWorkspaceButton
            getAccessTokenSilently={getAccessTokenSilently}
          />
          <ResetLayoutsToDefault />
          <ClearLayoutsRGL />
        </div>
      </Tooltip>
    </div>
  );
};

export default MoreOptionsButton;
